<template>
  <div class="container">
    <text-input
      :hint="placeholder"
      :label="label"
      :value="value"
      @input="onInput"
      @click="$emit('click')"
      :required="required"
      pattern="[0-9]*"
      inputmode="numeric"
      :maxlength="maxlength"
      :subhint="subhint"
      :validation-error="error"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
export default {
  name: "NumberInput",
  components: { TextInput },
  props: ["placeholder", "label", "value", "maxlength", "subhint"],
  data() {
    return {
      checked: false
    };
  },
  computed: {
    error() {
      if (this.checked) {
        if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "El número no es válido";
        }
      }
      return null;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        const numberRegex = /^[0-9]*$/;
        return numberRegex.test(this.value.trim());
      }
      return true;
    }
  }
};
</script>

<style scoped></style>
